export const SELECT = 'SELECT';
export const TOGGLE = 'TOGGLE';
export const SET_ALL = 'SET_ALL';
export const CLEAR_ALL = 'CLEAR_ALL';